import type { AxiosInstance } from 'axios';

import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';

import {
    ContextClient,
    MobileContextClient,
    MobileMaintenanceServiceEntryClient,
    MobileVehicleClient,
} from './client';

export * from './client';
export * from './create-axios-instance';

export const MOBILE_WEBVIEW_AXIOS_INSTANCE = symbolToken<AxiosInstance>('axiosInstance', false);
export const MOBILE_WEBVIEW_BFF_BASE_URL_TOKEN = symbolToken<string>('baseUrl', false);

@injectable()
export class MobileMaintenanceServiceEntryApi {
    client: MobileMaintenanceServiceEntryClient;

    constructor(
        @inject(MOBILE_WEBVIEW_AXIOS_INSTANCE) @optional() axiosInstance?: AxiosInstance,
        @inject(MOBILE_WEBVIEW_BFF_BASE_URL_TOKEN) @optional() baseUrl?: string
    ) {
        this.client = new MobileMaintenanceServiceEntryClient(baseUrl, axiosInstance);
    }
}

@injectable()
export class MobileVehicleApi {
    client: MobileVehicleClient;

    constructor(
        @inject(MOBILE_WEBVIEW_AXIOS_INSTANCE) @optional() axiosInstance?: AxiosInstance,
        @inject(MOBILE_WEBVIEW_BFF_BASE_URL_TOKEN) @optional() baseUrl?: string
    ) {
        this.client = new MobileVehicleClient(baseUrl, axiosInstance);
    }
}

@injectable()
export class MobileContextApi {
    client: MobileContextClient;

    constructor(
        @inject(MOBILE_WEBVIEW_AXIOS_INSTANCE) @optional() axiosInstance?: AxiosInstance,
        @inject(MOBILE_WEBVIEW_BFF_BASE_URL_TOKEN) @optional() baseUrl?: string
    ) {
        this.client = new MobileContextClient(baseUrl, axiosInstance);
    }
}

